import React, { useState } from 'react';
import './HomeScreen.css'; // Asegúrate de tener este archivo CSS para estilos
import { useHistory } from 'react-router-dom';
import TapTatSVG from './Iconos/TapTat.svg';
import SmileSVG from './Iconos/smile.svg';
import StarSVG from './Iconos/star.svg';
import PieChart from './Iconos/pie-chart.svg';
import SissorsSVG from './Iconos/scissors.svg';
import SettingSVG from './Iconos/settings.svg';
import perfilSVG from './Iconos/user-2.svg';
import mujerGif from './Imagenes/Gif/mujer.gif';
import likerGif from './Imagenes/Gif/likes.gif';
import perfil1SVG from './Iconos/user-1.svg';
import gif2 from './Imagenes/Gif/gif2.gif';
import gif3 from './Imagenes/Gif/gif3.gif';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const HomeScreen = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleNextClick = () => {
    // Aquí pones la lógica para ir al paso anterior
    history.push('/PantallaInicial');
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div>
      <Helmet>
        <title>Home - Taapt</title>
      </Helmet>
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-button" onClick={closeModal}>&times;</span>
            <h2>¡Bienvenido!</h2>
            <p>
              Estás navegando en una versión en fase de pruebas. Es posible que encuentres algunos errores o funcionalidades incompletas.<br/>
              ¡Agradecemos tu comprensión y tus comentarios para mejorar!
            </p>
            <button onClick={closeModal}>Entendido</button>
          </div>
        </div>
      )}
      <div className="home-screen">
        <div className="welcome-box">
          <h1>{t('Bienvenido')}</h1>
          <p>{t('Text1')}<br />{t('Text2')} <span className='home-subtitle'> {t('Text3')}</span> ?</p>
        </div>

        <button className="manage-brand-btn" onClick={handleNextClick}><img src={perfilSVG} alt="" />{t('Gestiona')}</button>
        <div className="welcome-section">
          <h2>{t('Text4')}<br /> {t('Text5')}</h2>
          <p>{t('Text6')} <br /> {t('Text7')}.</p>
        </div>
        <div className="assitent-wrappper">
          <div className="assistant-intro">
            <span className="home-subtitle">{t('Hola')} </span>
            {t('soy')} <span className="home-subtitle">Tap-Tat</span>,<br />
            <span>{t('asistente')} <br />{t('necesitas')}</span>
          </div>
        </div>
        <div className="assistant-icon">
          <img src={TapTatSVG} alt="Icono del asistente" />
        </div>
      </div>
      <div className='Second-container'>
        <div className='content-container'>

          <div className="text-content">
            <h1>{t('Gestion')}</h1>
            <p className="highlighted-text">{t('Potencia')}</p>
            <p>{t('Potencia2')}.</p>
            <p className="question-text">{t('Buscas')}</p>
            <p>{t('Buscas2')}.</p>
            <p className="question-text">{t('Mejora')}</p>
            <button className="manage-brand-btn2" onClick={handleNextClick}><img src={perfil1SVG} alt="" />{t('Gestiona')}</button>
          </div>

          <div className="image-content">
            <img src={mujerGif} alt="Mujer gesto pensativo" />
            <div className="interaction-count">
              <img src={likerGif} alt="likes" />
            </div>
          </div>
        </div>
        <div className='content-container'>
          <div className="image-content2">
            <img src={gif3} alt="pensando" />
          </div>
          <div className="text-content2">
            <h1>{t('Marketing2')}</h1>
            <p className="highlighted-text">{t('ProcesoIA')}.</p>
            <p>{t('PasoPaso')}.</p>
            <p className="question-text">{t('Objetivos')}.</p>
            <p>{t('Adapta')}.</p>
            <p className="question-text">{t('Comencemos')}</p>
            <button className="manage-brand-btn2" onClick={handleNextClick}><img src={perfil1SVG} alt="" />{t('Gestiona')}</button>
          </div>
        </div>
        <div className='content-container'>
          <div className="text-content">
            <h1>{t('WebTitle')}</h1>
            <p className="highlighted-text">{t('DiseñoWeb')}.</p>
            <p>{t('DiseñoWeb2')}.</p>
            <p className="question-text">{t('QuestionWeb')}.</p>
            <p>{t('QuestionWeb2')}.</p>
            <button className="manage-brand-btn2" onClick={handleNextClick}><img src={perfil1SVG} alt="" />{t('Gestiona')}</button>
          </div>

          <div className="image-content3">
            <img src={gif2} alt="cuadrados" />
          </div>
        </div>
        <div className="information-content-new">
        <h2 className="heading2">{t('Funciona')}</h2>
        <h3 className="subtitle3">{t('Sencillo')}</h3>

        <div className="steps-container">
          <div className="step-new">
            <div className="step-number-new">1</div>
            <div className="step-text-new">{t('Regístrate')}</div>
            <img className="step-icon-new" src={SmileSVG} alt="Smile" />
          </div>
          <div className="arrow-down-new">&#x2193;</div>
          <div className="step-new">
          <img className="step-icon-new" src={SissorsSVG} alt="Scissors" />
            <div className="step-text-new">{t('Crea')}</div>
            <div className="step-number-new">2</div>

          </div>
          <div className="arrow-down-new">&#x2193;</div>
          <div className="step-new">
            <div className="step-number-new">3</div>
            <div className="step-text-new">{t('Gestiona')}</div>
            <img className="step-icon-new" src={PieChart} alt="Pie Chart" />
          </div>
          <div className="arrow-down-new">&#x2193;</div>
          <div className="step-new">
          <img className="step-icon-new" src={SettingSVG} alt="Settings" />
            <div className="step-text-new">{t('Programa')}</div>
            <div className="step-number-new">4</div>
          </div>
          <div className="arrow-down-new">&#x2193;</div>
          <div className="final-step-new">
            <div className="step-text-final-new">{t('Y listo')}</div>
            <img className="step-icon-new" src={StarSVG} alt="Star" />
          </div>
        </div>
      </div>

      </div>
    </div>
  );
};

export default HomeScreen;
